import { render, staticRenderFns } from "./forYou.vue?vue&type=template&id=ac93fa08&scoped=true&"
import script from "./forYou.vue?vue&type=script&lang=js&"
export * from "./forYou.vue?vue&type=script&lang=js&"
import style0 from "./forYou.vue?vue&type=style&index=0&id=ac93fa08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac93fa08",
  null
  
)

export default component.exports